export default {
  bulkMaxSize: 'تعداد ارسال گروهی',
  bulkSupport: 'ارسال گروهی',
  callBackUrl: 'آدرس بازگشت',
  host: 'host',
  paymentUrl: 'آدرس درگاه',
  protocol: 'protocol',
  priority: 'اولویت',
  port: 'port',
  password: 'کلمه عبور',
  sendNumber: 'شماره ارسال',
  sendUrl: 'آدرس ارسال',
  terminalId: 'شناسه ترمینال',
  userName: 'نام کاربری',
  provider: 'ارائه دهنده سرویس',
  gatewayId: 'شناسه درگاه',
  map: 'نقشه',
  baraneh: 'بارانه',
  alopeyk: 'الوپیک',
  chapar: 'چاپار',
  mahex: 'ماهکس',
  bazargah: 'بازارگاه',
  tapin: 'تپین',
  melat: 'درگاه ملت',
  zarinpal: 'درگاه زرین پال',
  nasiba: 'درگاه نسیبا',
  mtyn: 'متین',
  badpa: 'بادپا',
  gmail: 'جیمیل',
  gama: 'گاما',
  magfa: 'مگفا',
  kavenegar: 'کاوه نگار',
  firebase: 'فایربیس',
  sendMethod: 'روش ارسال',
  externalId: 'کد خارجی',
  sendEmail: 'ایمیل ارسال',
  ecopeyk: 'اکوپیک',
  postex: 'پستکس',
  post: 'پست'
}
